module.exports = __webpack_public_path__ + "src/client/assets/bank-logos/capone360@3x.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/bank-logos/capone360@3x.png
// module id = 1160
// module chunks = 0